import { useTimesheet } from "./context";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import Icon from "../icon";
import { CIRCLE_CHECK_BIG } from "icons";
import { cn } from "utils";
import { ShimmerEffect } from "../shimmer";
import AcknowledgmentCard from "./card/acknowledgment";
export function AcknowledgementStatus({
  children,
  className,
  toolTipText,
  ...props
}) {
  const {
    data: { isAcknowledged },
  } = useTimesheet();

  if (typeof children === "function") {
    return children({ isAcknowledged });
  }

  if (!isAcknowledged) {
    return null;
  }

  return (
    <Tooltip {...props}>
      <TooltipTrigger>
        {children ? (
          children
        ) : (
          <Icon icon={CIRCLE_CHECK_BIG} className={className} />
        )}
      </TooltipTrigger>
      <TooltipContent>
        {toolTipText ? toolTipText : "Acknowledged"}
      </TooltipContent>
    </Tooltip>
  );
}

export function Acknowledgement({
  children,
  onAcknowledge,
  hideIfEntries,
  ...props
}) {
  const {
    data: { isAcknowledged, date, totalLogsInADay, entries },
  } = useTimesheet();

  if (typeof children === "function") {
    return children({ isAcknowledged, date, totalLogsInADay, onAcknowledge });
  }

  if (hideIfEntries) {
    if (entries.length > 0) {
      return null;
    }
  }

  return (
    <AcknowledgmentCard
      date={date}
      isAcknowledged={isAcknowledged}
      totalLogsInADay={totalLogsInADay}
      onAcknowledge={onAcknowledge}
      {...props}
    />
  );
}
